import { UnstyledButton } from '@mantine/core';
import { FC } from 'react';

import { color_mapping } from '@/constants/priority.ts';

import { Priority } from '@/models/appointment/Appointment.ts';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    priority: Priority;
    onClick?: () => void;
}

const PriorityMarker: FC<Props> = ({ priority, onClick }) => (
    <UnstyledButton onClick={onClick} className={cn(onClick ? 'cursor-pointer' : 'cursor-default')}>
        <div
            className={cn(
                'absolute right-0 top-0 h-0 w-0 border-[12px]',
                priority !== Priority.NONE && `border-${color_mapping[priority]}`,
                'border-b-transparent border-l-transparent'
            )}
        />
    </UnstyledButton>
);

export default PriorityMarker;
